import { Star } from "lucide-react";

import { ResponsiveTooltip } from "@krea/shared/design-system/ResponsiveTooltip";
import { cn } from "@krea/shared/utils";

const HighlightedCustomerSegmentIndicator = ({
  className,
}: {
  className: string;
}) => {
  const classNames = cn(
    "inline-block text-xs leading-normal align-middle w-5 h-5 text-center bg-green-600 flex items-center justify-center",
    className,
  );

  return (
    <ResponsiveTooltip
      className="max-w-[300px]"
      trigger={
        <div className={classNames}>
          <Star className="size-3.5 fill-white text-white" />
        </div>
      }
    >
      This application matches a customer segment that you are more likely to
      convert with your offering.
    </ResponsiveTooltip>
  );
};

export { HighlightedCustomerSegmentIndicator };
